// Mirrors the backend SoapySubdomain rules (SoapySubdomain.php): lowercase
// letters and hyphens only, must start and end with a letter, 3-52 chars.
export const SUBDOMAIN_REGEX = /^[a-z][-a-z]{1,50}[a-z]$/;

export const slugify = (input) => {
    const slug = (input ?? '')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 52)
        .replace(/-+$/, '');

    return SUBDOMAIN_REGEX.test(slug) ? slug : '';
};
